'use client'
import { ButtonNextLink } from '@/components/ButtonNextLink'
import { Pillow } from '@/components/Pillow/Pillow'
import { type LinkField, type SbBaseBlockProps, type StoryblokAsset } from '@/services/storyblok/storyblok'
import { getImgSrc, getLinkFieldURL } from '@/services/storyblok/Storyblok.helpers'
import { storyblokEditable } from '@storyblok/react'
import { pillowIconSlot } from './ProductButtonsBlock.css'

export type ProductButtonItemBlockProps = SbBaseBlockProps<{
  label: string
  pillowImage?: StoryblokAsset
  link: LinkField
}>

export const ProductButtonItemBlock = ({ blok }: ProductButtonItemBlockProps) => {
  const pillowImage = blok.pillowImage?.filename ? blok.pillowImage : undefined

  return (
    <ButtonNextLink
      {...storyblokEditable(blok)}
      href={getLinkFieldURL(blok.link, blok.label)}
      variant="secondary"
      size="medium"
      target={blok.link.target}
      rel={blok.link.rel}
      title={blok.link.title}
      Icon={
        pillowImage ? (
          <span className={pillowIconSlot}>
            <Pillow size="mini" src={getImgSrc(pillowImage.filename)} alt={pillowImage.alt} />
          </span>
        ) : undefined
      }
    >
      {blok.label}
    </ButtonNextLink>
  )
}
ProductButtonItemBlock.blockName = 'productButtonItem'
